import LogoSvg from "../../assets/images/logo.svg";
import { FullWidthContainer } from "../../common/components/layout/Container";
import Heading from "../../common/components/ui/Heading";
import Paragraph from "../../common/components/ui/Paragraph";
import { ExternalLinkButton } from "../../common/components/ui/buttons/ExternalLinkButton";
import { useTranslation, Trans } from "react-i18next";
import { Link, NavLink } from "react-router-dom";

const partnerLogos = [
  { filename: "sitra.png", title: "SITRA" },
  { filename: "cscp.png", title: "CSCP" },
  { filename: "solita.png", title: "Solita" },
  { filename: "hot_or_cool.png", title: "Hot or Cool" },
  { filename: "iclei.png", title: "ICLEI Europe" },
  { filename: "euro_health_net.png", title: "EuroHealthNet" },
  { filename: "zero_waste_estonia.svg", title: "Let's Do It Foundation" },
  { filename: "rohetiiger.png", title: "Zero Waste Estonia" },
  { filename: "athena.png", title: "Athena - RIC" },
  { filename: "expizo.png", title: "EKPIZO" },
  { filename: "sustainable_development_foundation.png", title: "SUSDEF" },
  { filename: "green_apes.png", title: "greenApes" },
  { filename: "deco.png", title: "DECO" },
  { filename: "circular_change.png", title: "Circular Change" },
  { filename: "city_of_ljubljana.png", title: "MOL" },
  { filename: "zeytince.png", title: "ZEYDD" },
] as const;

export const OrganizationInfo = () => {
  const { t } = useTranslation(["frontpage"]);

  return (
    <div className="bg-basic-background py-8">
      <FullWidthContainer className="divide-y divide-grey-20">
        <div className="bg-neutral-white px-6 py-8 md:px-10 md:py-11 rounded-lg items-center bg-windmillPattern bg-no-repeat bg-right-top bg-contain mb-8">
          <Heading
            level={2}
            type="headline-md-b"
            className="mb-3 text-neutral-100 md:mr-6"
          >
            {t("feedback.footer.title", { ns: "common" })}
          </Heading>
          <Paragraph type="body-md">
            <Trans
              i18nKey="feedback.footer.description"
              ns="common"
              components={{
                Link: (
                  <Link
                    to="mailto:info@pslifestyle.eu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="body-md-b"
                  />
                ),
              }}
            />
          </Paragraph>
        </div>
        <div className="py-8 flex flex-col items-start gap-8 lg:gap-[8em] justify-between lg:flex-row lg:items-center">
          <div className="flex flex-col items-start gap-4">
            <img className="h-12" src={LogoSvg} alt="PS Lifestyle" />

            <ExternalLinkButton
              url="http://pslifestyle.eu/"
              text={t("projectWebsite")}
              theme="secondary"
            />
          </div>
          <div className="flex flex-col flex-1 items-start gap-8 justify-between md:flex-row md:items-center">
            <img
              src="/images/flags/EU-flag.svg"
              height="107px"
              width="170px"
              alt="Flag of European Union"
            />
            <Paragraph type="body-md" className="md:ml-5 md:mt-0">
              {t("fundingInfo", { ns: "common" })}
            </Paragraph>
          </div>
        </div>
        <div className="py-8">
          <Heading level={1} type="title-lg" className="text-grey-60 mb-3">
            {t("partnersHeading")}
          </Heading>
          <div className="flex flex-wrap rounded-sm gap-2">
            {partnerLogos.map(({ filename, title }) => (
              <div
                key={filename}
                className="bg-neutral-white flex justify-center items-center h-[80px] w-[80px] md:h-[92px] md:w-[117px]"
              >
                <img
                  alt={title}
                  title={title}
                  src={`/images/partnerLogos/${filename}`}
                  className="grayscale"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-start gap-2 md:flex-row md:justify-between items-start py-8">
          <Paragraph
            type="body-md"
            className="pt-8 text-grey-60 text-left md:w-1/2"
          >
            {t("aiDisclosure")}
          </Paragraph>
          <NavLink
            className="pt-8 text-right body-md align-text-top"
            to="/privacynotice"
          >
            {t("cookieAndPrivacyPolicy", { ns: "common" })}
          </NavLink>
        </div>
      </FullWidthContainer>
    </div>
  );
};
